/*
 * File: route-transition.vue.ts
 * File Created: 2024-09-13 09:29:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:51:37
 * Modified By: Val Liu
 * -----
 */

import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class RouteTransition extends Vue {
    /// public ///////////////////////////////////////////////////////////////////////////
    /// direct props ////////////////////////////
    /// if path being set, use this one rather than take from $parent
    @Prop({
        type: String,
        required: false,
    })
    path: string | undefined;
    //////////////////////////////////////////////////////////////////////////////////////

    /// private //////////////////////////////////////////////////////////////////////////
    /// private helper
    private step: number = 0;
    @Watch("$parent.$route.path")
    private onRouteChanged(newValue: string, oldValue: string) {
        if (newValue.length >= oldValue.length) this.step++;
        else this.step--;
    }

    isChildRoute() {
        const path = this.path;
        const routePath = this.$route.path;
        if (path == null) return false;

        return routePath.length > path.length && routePath.indexOf(path) >= 0;
    }
    //////////////////////////////////////////////////////////////////////////////////////
}
